// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23000000%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Existing colors */
  --primary-color: #2c3e50;
  --secondary-color: #4a6eaf;
  --background-color: #ecf0f1;
  --text-color: #f9f9f9;

  /* Header and Footer colors */
  --header-bg: #1a252f; /* Matching background for seamless look */
  --header-text: #f9f9f9;
  --footer-bg: #141c24; /* Slightly darker than background */
  --footer-text: #f9f9f9;
}

.light-theme {
  /* Existing colors */
  --primary-color: #f9f9f9;
  --secondary-color: #4a6eaf;
  --background-color: #ffffff;
  --text-color: #2c3e50;

  /* Header and Footer colors */
  --header-bg: #4a6eaf; /* Using secondary color for visual interest */
  --header-text: #ffffff;
  --footer-bg: #34495e; /* Darker for grounding */
  --footer-text: #ffffff;
}

.dark-theme {
  /* Existing colors */
  --primary-color: #2c3e50;
  --secondary-color: #4a6eaf;
  --background-color: #1a252f;
  --text-color: #f9f9f9;

  /* Header and Footer colors */
  --header-bg: #1a252f; /* Matching background for seamless look */
  --header-text: #f9f9f9;
  --footer-bg: #141c24; /* Slightly darker than background */
  --footer-text: #f9f9f9;
}

* {
  font-family: 'Inter', sans-serif;
  font-size: 1.2rem;
  box-sizing: border-box;
}

body {
  display: grid;
  background-color: var(--primary-color);
  grid-template-rows: auto 1fr auto;
  height: 100vh; /* Changed from min-height to fixed height */
  margin: 0;
  gap: 0;
  overflow: hidden; /* Prevents scrolling on the body */
}

input,
button,
#player2name {
  width: fit-content;
  display: flex;
  align-self: center;
}

button {
  background-color: var(--secondary-color); /* React-like blue */
  color: var(--background-color);
  border: none;
  padding: 10px 16px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 6px;
  cursor: pointer;
  transition:
    background 0.3s ease,
    transform 0.1s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

button:hover {
  background-color: #0056b3; /* Darker blue */
  transform: translateY(-2px); /* Slight lift */
  color: white;
}

button:active {
  background-color: #004099;
  transform: translateY(0px);
}

button:disabled {
  background-color: #c0c0c0;
  cursor: not-allowed;
  box-shadow: none;
}

#randomizeButton,
#replayBtn {
  background-color: #6b9e6b;
  margin-left: auto;
}

input {
  width: 100%;
  padding: 10px;
  font-size: 16px;
  border: 2px solid #ddd;
  border-radius: 6px;
  outline: none;
  transition:
    border-color 0.3s ease,
    box-shadow 0.2s ease;
}

input:focus {
  border-color: #007bff;
  box-shadow: 0 0 6px rgba(0, 123, 255, 0.3);
}

input.error {
  border-color: #dc3545; /* Bootstrap danger red */
  box-shadow: 0 0 6px rgba(220, 53, 69, 0.3);
}

input::placeholder {
  color: #999;
}

select {
  /* Basic appearance */
  appearance: none;
  -moz-appearance: none; /* Firefox */
  -webkit-appearance: none; /* Chrome/Safari */

  /* Basic styles */
  padding: 6px 8px;
  font-size: 16px;
  border: 1px solid var(--primary-color);
  border-radius: 4px;
  background-color: var(--secondary-color);
  cursor: pointer;

  color: var(--background-color);

  /* Add a custom dropdown arrow */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 12px top 50%;
  background-size: 12px auto;
  padding-right: 40px; /* Space for the arrow */
}

/* Remove default arrow in IE */
select::-ms-expand {
  display: none;
}

/* Hover state */
select:hover {
  border-color: #888;
}

/* Focus state */
select:focus {
  border-color: #4a90e2;
  outline: none;
  box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.2);
}

option {
  padding: 8px 12px;
  background-color: var(--secondary-color);
  color: var(--background-color);
  font-size: 0.8rem;
}

/* Hover state for options (limited support) */
option:hover {
  background-color: #f0f0f0;
}

#player1board,
#player2board {
  display: grid;
  grid-template-columns: repeat(1fr, 50px);
  grid-template-rows: repeat(1fr, 50px);
  /* max-width: 500px; */
  max-height: 516px;
  width: 100%;
  height: 100%;
  border: 8px solid var(--footer-bg);
  border-radius: 8px;
}

#player1container,
#player2container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

#bodyContainer {
  display: flex;
  flex-direction: column;
  height: 100%; /* Takes full height of its grid cell */
  justify-content: space-evenly; /* Distributes space evenly */
  gap: 0; /* Reduced gap */
  padding: 1rem 0; /* Reduced padding */
  overflow: auto; /* Allows scrolling if content overflows */
}

#boardsContainer {
  display: flex;
  justify-content: center;
  padding: 0px;
  gap: 50px;
}

#titleContainer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  /* Remove margin-top */
}

#settingsContainer,
#optionsContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

#player1nameLabel {
  max-width: 500px;
  max-height: 50px;
  overflow-wrap: anywhere;
  overflow: hidden;
}

#player1nameContainer {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 1rem;
}

.cell {
  width: 50px;
  height: 50px;
  background-color: lightblue;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid black;
}

.disabled {
  pointer-events: none;
}

.hidden {
  display: none;
}

#instructionsLabel {
  padding: 12px 16px;
  background-color: var(--text-color); /* Ensures background color is applied */
  border: 2px solid var(--text-color);
  border-radius: 30px;
  box-shadow:
    0 4px 10px rgba(0, 0, 0, 0.3),
    0 0 10px var(--primary-color);
  font-weight: bold;
  color: var(--primary-color);
  transition: transform 0.2s ease-in-out;
  font-style: italic;
  font-weight: 300;
  animation: casinoBorder 1s infinite linear;
}

label,
#speedLabel,
#nameLabel,
#player2name {
  color: var(--text-color);
  font-size: 1rem;
}

#playersTurn {
  display: inline-block; /* Makes the border wrap tightly around text */
  padding: 5px 10px; /* Adds spacing inside the border */
  border: 2px solid #333; /* Thin border with a dark color */
  border-radius: 10px; /* Rounded corners */
  font-size: 16px; /* Adjust font size */
  font-weight: bold; /* Makes the text stand out */
  text-shadow:
    -1px -1px 0 #000,
    1px -1px 0 #000,
    -1px 1px 0 #000,
    1px 1px 0 #000; /* Creates an outline effect */
}

footer,
#header {
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  padding: 10px 0;
}

#header {
  background-color: var(--header-bg);
  color: var(--header-text);
  font-size: 2rem;
  height: 60px; /* Fixed height instead of max-height */
}

footer {
  background-color: var(--footer-bg);
  color: var(--footer-text);
  font-size: 1rem;
  height: 40px; /* Fixed height */
}

@keyframes casinoBorder {
  0% {
    border-color: #ff0000;
  }
  50% {
    border-color: #ffff00;
  }
  100% {
    border-color: #ff0000;
  }
}
`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,0BAA0B;EAC1B,2BAA2B;EAC3B,qBAAqB;;EAErB,6BAA6B;EAC7B,oBAAoB,EAAE,0CAA0C;EAChE,sBAAsB;EACtB,oBAAoB,EAAE,oCAAoC;EAC1D,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,0BAA0B;EAC1B,2BAA2B;EAC3B,qBAAqB;;EAErB,6BAA6B;EAC7B,oBAAoB,EAAE,8CAA8C;EACpE,sBAAsB;EACtB,oBAAoB,EAAE,yBAAyB;EAC/C,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,0BAA0B;EAC1B,2BAA2B;EAC3B,qBAAqB;;EAErB,6BAA6B;EAC7B,oBAAoB,EAAE,0CAA0C;EAChE,sBAAsB;EACtB,oBAAoB,EAAE,oCAAoC;EAC1D,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,iCAAiC;EACjC,aAAa,EAAE,4CAA4C;EAC3D,SAAS;EACT,MAAM;EACN,gBAAgB,EAAE,mCAAmC;AACvD;;AAEA;;;EAGE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,wCAAwC,EAAE,oBAAoB;EAC9D,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf;;uBAEqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB,EAAE,gBAAgB;EAC3C,2BAA2B,EAAE,gBAAgB;EAC7C,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb;;wBAEsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB,EAAE,yBAAyB;EAChD,0CAA0C;AAC5C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,qBAAqB,EAAE,YAAY;EACnC,wBAAwB,EAAE,kBAAkB;;EAE5C,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;;EAEf,8BAA8B;;EAE9B,gCAAgC;EAChC,yDAAof;EACpf,4BAA4B;EAC5B,uCAAuC;EACvC,0BAA0B;EAC1B,mBAAmB,EAAE,wBAAwB;AAC/C;;AAEA,+BAA+B;AAC/B;EACE,aAAa;AACf;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,qBAAqB;EACrB,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,wCAAwC;EACxC,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA,8CAA8C;AAC9C;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,wCAAwC;EACxC,qCAAqC;EACrC,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAE,uCAAuC;EACrD,6BAA6B,EAAE,6BAA6B;EAC5D,MAAM,EAAE,gBAAgB;EACxB,eAAe,EAAE,oBAAoB;EACrC,cAAc,EAAE,0CAA0C;AAC5D;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mCAAmC,EAAE,wCAAwC;EAC7E,mCAAmC;EACnC,mBAAmB;EACnB;;iCAE+B;EAC/B,iBAAiB;EACjB,2BAA2B;EAC3B,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;;;;EAIE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,qBAAqB,EAAE,8CAA8C;EACrE,iBAAiB,EAAE,mCAAmC;EACtD,sBAAsB,EAAE,kCAAkC;EAC1D,mBAAmB,EAAE,oBAAoB;EACzC,eAAe,EAAE,qBAAqB;EACtC,iBAAiB,EAAE,6BAA6B;EAChD;;;;kBAIgB,EAAE,8BAA8B;AAClD;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,eAAe;EACf,YAAY,EAAE,uCAAuC;AACvD;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,eAAe;EACf,YAAY,EAAE,iBAAiB;AACjC;;AAEA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;AACF","sourcesContent":[":root {\r\n  /* Existing colors */\r\n  --primary-color: #2c3e50;\r\n  --secondary-color: #4a6eaf;\r\n  --background-color: #ecf0f1;\r\n  --text-color: #f9f9f9;\r\n\r\n  /* Header and Footer colors */\r\n  --header-bg: #1a252f; /* Matching background for seamless look */\r\n  --header-text: #f9f9f9;\r\n  --footer-bg: #141c24; /* Slightly darker than background */\r\n  --footer-text: #f9f9f9;\r\n}\r\n\r\n.light-theme {\r\n  /* Existing colors */\r\n  --primary-color: #f9f9f9;\r\n  --secondary-color: #4a6eaf;\r\n  --background-color: #ffffff;\r\n  --text-color: #2c3e50;\r\n\r\n  /* Header and Footer colors */\r\n  --header-bg: #4a6eaf; /* Using secondary color for visual interest */\r\n  --header-text: #ffffff;\r\n  --footer-bg: #34495e; /* Darker for grounding */\r\n  --footer-text: #ffffff;\r\n}\r\n\r\n.dark-theme {\r\n  /* Existing colors */\r\n  --primary-color: #2c3e50;\r\n  --secondary-color: #4a6eaf;\r\n  --background-color: #1a252f;\r\n  --text-color: #f9f9f9;\r\n\r\n  /* Header and Footer colors */\r\n  --header-bg: #1a252f; /* Matching background for seamless look */\r\n  --header-text: #f9f9f9;\r\n  --footer-bg: #141c24; /* Slightly darker than background */\r\n  --footer-text: #f9f9f9;\r\n}\r\n\r\n* {\r\n  font-family: 'Inter', sans-serif;\r\n  font-size: 1.2rem;\r\n  box-sizing: border-box;\r\n}\r\n\r\nbody {\r\n  display: grid;\r\n  background-color: var(--primary-color);\r\n  grid-template-rows: auto 1fr auto;\r\n  height: 100vh; /* Changed from min-height to fixed height */\r\n  margin: 0;\r\n  gap: 0;\r\n  overflow: hidden; /* Prevents scrolling on the body */\r\n}\r\n\r\ninput,\r\nbutton,\r\n#player2name {\r\n  width: fit-content;\r\n  display: flex;\r\n  align-self: center;\r\n}\r\n\r\nbutton {\r\n  background-color: var(--secondary-color); /* React-like blue */\r\n  color: var(--background-color);\r\n  border: none;\r\n  padding: 10px 16px;\r\n  font-size: 16px;\r\n  font-weight: 500;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  transition:\r\n    background 0.3s ease,\r\n    transform 0.1s ease;\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\nbutton:hover {\r\n  background-color: #0056b3; /* Darker blue */\r\n  transform: translateY(-2px); /* Slight lift */\r\n  color: white;\r\n}\r\n\r\nbutton:active {\r\n  background-color: #004099;\r\n  transform: translateY(0px);\r\n}\r\n\r\nbutton:disabled {\r\n  background-color: #c0c0c0;\r\n  cursor: not-allowed;\r\n  box-shadow: none;\r\n}\r\n\r\n#randomizeButton,\r\n#replayBtn {\r\n  background-color: #6b9e6b;\r\n  margin-left: auto;\r\n}\r\n\r\ninput {\r\n  width: 100%;\r\n  padding: 10px;\r\n  font-size: 16px;\r\n  border: 2px solid #ddd;\r\n  border-radius: 6px;\r\n  outline: none;\r\n  transition:\r\n    border-color 0.3s ease,\r\n    box-shadow 0.2s ease;\r\n}\r\n\r\ninput:focus {\r\n  border-color: #007bff;\r\n  box-shadow: 0 0 6px rgba(0, 123, 255, 0.3);\r\n}\r\n\r\ninput.error {\r\n  border-color: #dc3545; /* Bootstrap danger red */\r\n  box-shadow: 0 0 6px rgba(220, 53, 69, 0.3);\r\n}\r\n\r\ninput::placeholder {\r\n  color: #999;\r\n}\r\n\r\nselect {\r\n  /* Basic appearance */\r\n  appearance: none;\r\n  -moz-appearance: none; /* Firefox */\r\n  -webkit-appearance: none; /* Chrome/Safari */\r\n\r\n  /* Basic styles */\r\n  padding: 6px 8px;\r\n  font-size: 16px;\r\n  border: 1px solid var(--primary-color);\r\n  border-radius: 4px;\r\n  background-color: var(--secondary-color);\r\n  cursor: pointer;\r\n\r\n  color: var(--background-color);\r\n\r\n  /* Add a custom dropdown arrow */\r\n  background-image: url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23000000%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E');\r\n  background-repeat: no-repeat;\r\n  background-position: right 12px top 50%;\r\n  background-size: 12px auto;\r\n  padding-right: 40px; /* Space for the arrow */\r\n}\r\n\r\n/* Remove default arrow in IE */\r\nselect::-ms-expand {\r\n  display: none;\r\n}\r\n\r\n/* Hover state */\r\nselect:hover {\r\n  border-color: #888;\r\n}\r\n\r\n/* Focus state */\r\nselect:focus {\r\n  border-color: #4a90e2;\r\n  outline: none;\r\n  box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.2);\r\n}\r\n\r\noption {\r\n  padding: 8px 12px;\r\n  background-color: var(--secondary-color);\r\n  color: var(--background-color);\r\n  font-size: 0.8rem;\r\n}\r\n\r\n/* Hover state for options (limited support) */\r\noption:hover {\r\n  background-color: #f0f0f0;\r\n}\r\n\r\n#player1board,\r\n#player2board {\r\n  display: grid;\r\n  grid-template-columns: repeat(1fr, 50px);\r\n  grid-template-rows: repeat(1fr, 50px);\r\n  /* max-width: 500px; */\r\n  max-height: 516px;\r\n  width: 100%;\r\n  height: 100%;\r\n  border: 8px solid var(--footer-bg);\r\n  border-radius: 8px;\r\n}\r\n\r\n#player1container,\r\n#player2container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n#bodyContainer {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%; /* Takes full height of its grid cell */\r\n  justify-content: space-evenly; /* Distributes space evenly */\r\n  gap: 0; /* Reduced gap */\r\n  padding: 1rem 0; /* Reduced padding */\r\n  overflow: auto; /* Allows scrolling if content overflows */\r\n}\r\n\r\n#boardsContainer {\r\n  display: flex;\r\n  justify-content: center;\r\n  padding: 0px;\r\n  gap: 50px;\r\n}\r\n\r\n#titleContainer {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 20px;\r\n  /* Remove margin-top */\r\n}\r\n\r\n#settingsContainer,\r\n#optionsContainer {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n#player1nameLabel {\r\n  max-width: 500px;\r\n  max-height: 50px;\r\n  overflow-wrap: anywhere;\r\n  overflow: hidden;\r\n}\r\n\r\n#player1nameContainer {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  gap: 1rem;\r\n}\r\n\r\n.cell {\r\n  width: 50px;\r\n  height: 50px;\r\n  background-color: lightblue;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border: 1px solid black;\r\n}\r\n\r\n.disabled {\r\n  pointer-events: none;\r\n}\r\n\r\n.hidden {\r\n  display: none;\r\n}\r\n\r\n#instructionsLabel {\r\n  padding: 12px 16px;\r\n  background-color: var(--text-color); /* Ensures background color is applied */\r\n  border: 2px solid var(--text-color);\r\n  border-radius: 30px;\r\n  box-shadow:\r\n    0 4px 10px rgba(0, 0, 0, 0.3),\r\n    0 0 10px var(--primary-color);\r\n  font-weight: bold;\r\n  color: var(--primary-color);\r\n  transition: transform 0.2s ease-in-out;\r\n  font-style: italic;\r\n  font-weight: 300;\r\n  animation: casinoBorder 1s infinite linear;\r\n}\r\n\r\nlabel,\r\n#speedLabel,\r\n#nameLabel,\r\n#player2name {\r\n  color: var(--text-color);\r\n  font-size: 1rem;\r\n}\r\n\r\n#playersTurn {\r\n  display: inline-block; /* Makes the border wrap tightly around text */\r\n  padding: 5px 10px; /* Adds spacing inside the border */\r\n  border: 2px solid #333; /* Thin border with a dark color */\r\n  border-radius: 10px; /* Rounded corners */\r\n  font-size: 16px; /* Adjust font size */\r\n  font-weight: bold; /* Makes the text stand out */\r\n  text-shadow:\r\n    -1px -1px 0 #000,\r\n    1px -1px 0 #000,\r\n    -1px 1px 0 #000,\r\n    1px 1px 0 #000; /* Creates an outline effect */\r\n}\r\n\r\nfooter,\r\n#header {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  font-weight: bold;\r\n  padding: 10px 0;\r\n}\r\n\r\n#header {\r\n  background-color: var(--header-bg);\r\n  color: var(--header-text);\r\n  font-size: 2rem;\r\n  height: 60px; /* Fixed height instead of max-height */\r\n}\r\n\r\nfooter {\r\n  background-color: var(--footer-bg);\r\n  color: var(--footer-text);\r\n  font-size: 1rem;\r\n  height: 40px; /* Fixed height */\r\n}\r\n\r\n@keyframes casinoBorder {\r\n  0% {\r\n    border-color: #ff0000;\r\n  }\r\n  50% {\r\n    border-color: #ffff00;\r\n  }\r\n  100% {\r\n    border-color: #ff0000;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
